import { render, staticRenderFns } from "./SelectItemModal.vue?vue&type=template&id=2d079690&"
import script from "./SelectItemModal.vue?vue&type=script&lang=js&"
export * from "./SelectItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports